module.exports = __webpack_public_path__ + "img/soldadura.9914a3c4.png";